import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';

const SEO = ({ title, description, pageKey, defaultTitle, defaultDescription, defaultSchema, type = 'website', image }) => {
    // Priority: Firestore Data > pageKey prop > direct props > defaults
    const [meta, setMeta] = useState({
        title: title || defaultTitle || 'BPO Consultants PH',
        description: description || defaultDescription || 'Leading BPO Consulting Firm in the Philippines',
        image: image || '',
        isCrawlable: true,
        schemaMarkup: defaultSchema || ''
    });
    const [globalSettings, setGlobalSettings] = useState({ isCrawlable: true });

    useEffect(() => {
        const fetchMeta = async () => {
            try {
                // Fetch Global Settings
                const globalRef = doc(db, 'page_meta', 'global_settings');
                const globalSnap = await getDoc(globalRef);
                if (globalSnap.exists()) {
                    setGlobalSettings({ isCrawlable: globalSnap.data().isCrawlable !== false });
                }

                // Fetch Page Meta if pageKey is present
                if (pageKey) {
                    const docRef = doc(db, 'page_meta', pageKey);
                    const docSnap = await getDoc(docRef);

                    if (docSnap.exists()) {
                        const data = docSnap.data();
                        setMeta(prev => ({
                            ...prev,
                            ...data,
                            schemaMarkup: data.schemaMarkup || prev.schemaMarkup
                        }));
                    }
                }
            } catch (error) {
                console.error("Error fetching meta tags:", error);
            }
        };

        fetchMeta();
    }, [pageKey]);

    // Determine robot tag content
    const robotsContent = (globalSettings.isCrawlable && meta.isCrawlable !== false)
        ? 'index, follow'
        : 'noindex, nofollow';

    const displayTitle = meta.title;

    return (
        <Helmet>
            <title>{displayTitle}</title>
            <meta name="description" content={meta.description} />
            <meta name="robots" content={robotsContent} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content={type} />
            <meta property="og:title" content={displayTitle} />
            <meta property="og:description" content={meta.description} />
            {meta.image && <meta property="og:image" content={meta.image} />}

            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={displayTitle} />
            <meta name="twitter:description" content={meta.description} />
            {meta.image && <meta name="twitter:image" content={meta.image} />}

            {/* Schema Markup */}
            {meta.schemaMarkup && (
                <script type="application/ld+json">
                    {meta.schemaMarkup}
                </script>
            )}
        </Helmet>
    );
};

export default SEO;
